import React, {useState, useContext} from 'react'
import {Context} from '../index';
import config from '../config';

export default function RegistrationForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [position, setPosition] = useState('');
    const {store} = useContext(Context);

    const positions = config.positionNames;

    return (
        <div>
            <input
                type='text'
                value={email}
                placeholder='логин'
                onChange={event => setEmail(event.target.value)}
            />
            <input
                type="password"
                value={password}
                placeholder='пароль'
                onChange={event => setPassword(event.target.value)}
            />
            <select value={position} onChange={(e) => setPosition(e.target.value)}>
                <option value="">Выберите должность</option>
                {positions.map((pos, index) => {
                    return (
                        <option key={index} value={pos}>
                            {pos}
                        </option>
                    );
                })}
            </select>
            <button onClick={() => {
                store.registration(email, password, position);
                setEmail('');
                setPassword('');
                setPosition('');
            }}>
                Регистрация
            </button>
        </div>
    )
}
